<div class="loading-container">
  @switch (type) {
    @case (0) {
      <div class="spinner-loader">
        <mat-spinner mode="indeterminate" diameter="24" />
      </div>
    }

    @default {
      <span>invalid loading type: {{ type }}</span>
    }
  }
</div>
